<template>
  <div>
    <el-row type="flex">
      <el-col :span="24">
        <ra-card>
          <template slot="header">
            <div class="title">
              <p>{{ pagination.total }} Users</p>
              <el-radio-group v-model="view" size="medium">
                <el-radio label="test">Test Users</el-radio>
                <el-radio label="live">Live Users</el-radio>
              </el-radio-group>
            </div>
            <div class="is-flex">
              <import-users
                v-if="userCan('authx', 'user.importbatch')"
                :app-name="appName"
                :app-code="appCode"
                @imported="
                  getAppUsers();
                  setImported = true;
                "
              />
            </div>
          </template>
          <template slot="content">
            <el-table
              :data="users"
              v-loading="loading"
              :empty-text="'No users'"
            >
              <el-table-column prop="ID">
                <template slot="header">
                  <span class="ra-table--header">
                    Identifier
                  </span>
                </template>
                <template slot-scope="scope">
                  <p>{{ scope.row.identifier }}</p>
                </template>
              </el-table-column>
              <el-table-column prop="status">
                <template slot="header">
                  <span class="ra-table--header">
                    Status
                  </span>
                </template>
                <template slot-scope="scope">
                  <el-tag
                    :type="scope.row.status_id === 1 ? 'success' : 'warning'"
                    size="mini"
                  >
                    {{ scope.row.status && scope.row.status.label }}
                  </el-tag>
                </template>
              </el-table-column>

              <el-table-column prop="created_at">
                <template slot="header">
                  <span class="ra-table--header">
                    Created on
                  </span>
                </template>
                <template slot-scope="scope">
                  <p>
                    {{ mFormatShortDate(scope.row.created_at, "d-m-y") }} -
                    {{ mFormatTime(scope.row.created_at) }}
                  </p>
                </template>
              </el-table-column>

              <el-table-column prop="modified_at">
                <template slot="header">
                  <span class="ra-table--header">
                    Updated on
                  </span>
                </template>
                <template slot-scope="scope">
                  <p>
                    {{ mFormatShortDate(scope.row.modified_at, "d-m-y") }} -
                    {{ mFormatTime(scope.row.modified_at) }}
                  </p>
                </template>
              </el-table-column>

              <el-table-column width="80">
                <template slot-scope="scope">
                  <el-dropdown class="more" @command="command">
                    <span> <i class="ra-icon--more-vertical"></i></span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item
                        :command="{ action: 'user', code: scope.row.code }"
                      >
                        View User</el-dropdown-item
                      >
                    </el-dropdown-menu>
                  </el-dropdown>
                </template>
              </el-table-column>
            </el-table>
            <ra-pagination
              v-if="dataFound"
              :from="from"
              :to="to"
              :total="total"
              :pageSize="pagination.perPage"
              :current-page.sync="currentPage"
            />
          </template>
        </ra-card>
      </el-col>
    </el-row>
    <authx-app-user
      :show.sync="showAuthXUser"
      :app-code="appCode"
      :user-code="user.code"
    />
  </div>
</template>

<script>
import apiConstants from "@/apiConstants";
import AuthxAppUser from "@/components/Products/AuthX/Applications/Users/AuthxAppUser";
import ImportUsers from "@/components/Products/AuthX/Applications/Users/ImportUsers";

const paging = {
  perPage: 50,
  currentPage: 1,
  total: 0
};

export default {
  name: "Users",
  props: {
    appName: {
      type: String,
      default: ""
    },
    appCode: {
      type: String,
      default: ""
    },
    imported: {
      type: Boolean,
      default: false
    }
  },
  components: {
    ImportUsers,
    AuthxAppUser
  },
  data() {
    return {
      loading: true,
      pageData: [],
      currentPage: 1,
      pagination: { ...paging },
      user: {
        code: null
      },
      showAuthXUser: false,
      view: "test"
    };
  },
  computed: {
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },

    from() {
      return this.pagination.perPage * (this.currentPage - 1);
    },

    total() {
      return this.pagination.total;
    },

    dataFound() {
      return !!this.pageData.length;
    },
    setImported: {
      get() {
        return this.imported;
      },
      set(value) {
        this.$emit("update:imported", value);
      }
    },
    liveUsers() {
      return this.pageData && this.pageData.filter(user => user.is_test === 0);
    },
    testUsers() {
      return this.pageData && this.pageData.filter(user => user.is_test === 1);
    },
    users() {
      return this.view === "live" ? this.liveUsers : this.testUsers;
    }
  },
  watch: {
    appCode() {
      this.getAppUsers();
    },
    currentPage() {
      this.getAppUsers();
    }
  },

  created() {
    if (this.appCode) {
      this.getAppUsers();
    }
  },

  methods: {
    getPaginationParams() {
      const { currentPage, pagination } = this;
      return `page_size=${pagination.perPage}&page=${currentPage}`;
    },

    getAppUsers() {
      this.loading = true;
      const apiUrl = `apps/${this.appCode}/users`;
      this.$http
        .post(
          apiUrl,
          {
            method: "GET",
            params: `embeds=["status"]&${this.getPaginationParams()}`
          },
          {
            headers: {
              "data-baseurl-namespace": apiConstants.URLS.AUTHX
            }
          }
        )
        .then(response => {
          const resData = response.data;
          if (resData.status === "error") {
            this.handleErrors(resData);
            this.loading = false;
          } else {
            this.pageData = resData.list;
            this.pagination.total = resData.pagination.total_count;
            this.loading = false;
          }
        })
        .catch(() => {
          this.notification("Error", "An unknown error occurred", "danger");
          this.loading = false;
        });
    },
    command(command) {
      const { action, code } = command;
      if (action === "user") {
        this.user.code = code;
        this.showAuthXUser = true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.title {
  display: flex;
  align-items: center;

  p {
    width: 80px;
  }
}
</style>
